// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"de5b2a68","253":"1c1f8b13","585":"2dc9994b","702":"013d5325","821":"96c727f6","962":"488e8b9f","964":"e320140e"}[chunkId] + ".css";
};